import * as types from './types';

const initialState = {
  cardHolder: '',
  cardNumber: '',
  expirationDate: {
    month: '',
    year: ''
  },
  cvv: '',
  iban: '',
  source: null,
  transId: undefined,
  transfer: false,
  isComplete: false,
  loading: false,
  success: false,
};

type PaySetup = {
  source: string,
  id: string,
}

type PayAction = {
  type: typeof types[keyof typeof types];
  payload?: Partial<types.PayState> | PaySetup;
};

export default function payReducer(state = initialState, action: PayAction) {
  const { type, payload } = action;
  switch (type) {
    case 'SEND_PAYEMENT':
      return { ...state, loading: true };
    case 'RECEIVE_PAYEMENT_SUCCESS':
      return { ...state, loading: false, success: true };
    case 'RECEIVE_PAYEMENT_FAIL':
      return { ...state, loading: false, success: false };
    case 'UPDATE_PAYMENT_INFO':
      return { ...state, source: (payload as PaySetup).source, transId: (payload as PaySetup).id }
    case 'UPDATE_CARD_HOLDER':
      return { ...state, cardHolder: payload };
    case 'UPDATE_CARD_NUMBER':
      return { ...state, cardNumber: payload };
    case 'UPDATE_EXPIRATION_DATE':
      return { ...state, expirationDate: payload };
    case 'UPDATE_CVV':
      return { ...state, cvv: payload };
    case 'UPDATE_IBAN':
      return { ...state, iban: payload };
    case 'UPDATE_TRANSFER':
      return { ...state, transfer: payload };
    default:
      return { ...state };
  }
}
